import { Base } from 'src/api/Base'

export class UserAPI extends Base {
  static get entity() {
    return 'users'
  }

  static async getCurrent() {
    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).get(`/${this.entity}/current`)
    return data
  }

  static async setSetting({ value, setting }) {
    const body = {
      value,
    }
    const params = {
      setting,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/setting`, body, { params })

    return data
  }
}
